var map = {
	"./sso_logo_service_id_1.png": 40615,
	"./sso_logo_service_id_2.png": 49971,
	"./sso_logo_service_id_3.png": 8645,
	"./sso_logo_service_id_4.png": 34188,
	"./sso_logo_service_id_6.png": 36331,
	"./sso_logo_service_id_8.png": 45194
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 27857;